import * as PlaneSpinner from './components/PlaneSpinner.css';
export default {
    PlaneSpinner
};
